import { AnalyticsEvent, AnalyticsEventProperties } from '@/analytics/schema/events.schema'

/**
 * Custom Instructions Analytics Props
 *
 * Derives the analytics payload for a custom-instructions save. Lives here rather than inline in
 * the component so the raw instruction text has no path into an analytics call: it is
 * user-authored legal text and may name clients, adverse parties, or matter strategy.
 */
export function getCustomInstructionsAnalyticsProps(customInstructions: string): AnalyticsEventProperties[AnalyticsEvent.CustomInstructionsSaved] {
  return {
    characterCount: customInstructions.length,
    isCleared: customInstructions.trim().length === 0,
  }
}
